import { render, staticRenderFns } from "./CHART_AREA.vue?vue&type=template&id=10847892&scoped=true"
import script from "./CHART_AREA.vue?vue&type=script&lang=ts"
export * from "./CHART_AREA.vue?vue&type=script&lang=ts"
import style0 from "./CHART_AREA.vue?vue&type=style&index=0&id=10847892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10847892",
  null
  
)

export default component.exports